import type { StateCreator } from "zustand";
import type { LineOperationalData } from "../graphql/queries";

export const operationalDataKey = (line: string, year: number): string =>
  `${line}:${year}`;

export interface OperationalDataSlice {
  operationalData: LineOperationalData | null;
  /**
   * Writes only when the response's (line, year) matches the key captured at
   * fetch time. A stale in-flight response for a previously selected line is
   * rejected, so it can never render under the new line's header.
   * `null` clears the slice (empty state) while still honouring the guard.
   * Returns `true` if the write landed.
   */
  setOperationalData: (
    data: LineOperationalData | null,
    expectedKey: string,
  ) => boolean;
  clearOperationalData: () => void;
}

export const operationalDataSlice: StateCreator<
  OperationalDataSlice,
  [["zustand/immer", never]],
  [],
  OperationalDataSlice
> = (set) => ({
  operationalData: null,
  setOperationalData: (data, expectedKey) => {
    if (
      data !== null &&
      operationalDataKey(data.line, data.year) !== expectedKey
    ) {
      return false;
    }
    set((s) => {
      s.operationalData = data;
    });
    return true;
  },
  clearOperationalData: () =>
    set((s) => {
      s.operationalData = null;
    }),
});
